import React from 'react';
import './Footer.css'; // This is correct - file is in same directory

const Footer = () => {
    return ( <
        footer className = "footer" >
        <
        div className = "container footer-container" >
        <
        div className = "footer-bottom" >
        <
        p > & copy; 2026 Dynamic Enterprises.All rights reserved. < /p> <
        /div> <
        /div> <
        /footer>
    );
};

export default Footer;